import React from 'react';
import { Modal } from 'antd';

export interface VideoPreviewProps {
  visible: boolean;
  src: string;
  title?: string;
  width?: number;
  onClose: () => void;
}

const VideoPreview: React.FC<VideoPreviewProps> = ({ visible, src, title = '视频预览', width = 560, onClose }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={title}
      width={width}
      centered
    >
      {src ? (
        <div style={{ textAlign: 'center' }}>
          <video
            src={src}
            controls
            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
          >
            您的浏览器不支持视频标签。
          </video>
        </div>
      ) : null}
    </Modal>
  );
};

export default VideoPreview; 